import {
  ComponentSingleStyleConfig,
  Icon,
  useStyleConfig,
} from "@chakra-ui/react";
import React, { ReactElement } from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import { FaTrashAlt } from "react-icons/fa";

import { IconButtonBase } from "../IconButtonBase/IconButtonBase";

export type DeleteIconButtonProps = {
  icon?: ReactElement;
  size?: "sm" | "md" | "lg";
  tipMessage?: string;
  ariaLabel: string;

  onClick?: () => void;
} & ComponentStyleProps;

export const DeleteIconButton = ({
  icon = <Icon as={FaTrashAlt} />,
  size = "md",
  tipMessage,
  ariaLabel,

  onClick,

  sx,
  ...rest
}: DeleteIconButtonProps) => {
  const styles = useStyleConfig("DeleteIconButtonStyles");

  return (
    <IconButtonBase
      icon={icon}
      size={size}
      tipMessage={tipMessage}
      ariaLabel={ariaLabel}
      onClick={onClick}
      sx={{ ...styles, ...sx }}
      {...rest}
    />
  );
};

export const DeleteIconButtonStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    // color: "gray.200",
    //
    // _hover: {
    //   bgColor: "gray.100",
    //   color: "gray.600",
    // },
  },
};
